<template>
  <!--
      作者：123
      时间：2023-11-10
      描述：接单点位-路线规划
  -->
  <el-dialog title="技师接单范围" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false" :close-on-press-escape="false">
    <!-- <Getpoint :form="newform" @getMapdata="getMapdataFunc" @chose="choseFunc" :newdata="newdata"></Getpoint> -->
    <div>
     
      <el-input v-model="scope" type="number" >
        <template slot="append">km</template></el-input>
    </div>
    <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
      </div>
  </el-dialog>
  <!-- <div>
123
  </div> -->
</template>

<script>
import Technician from "@/api/technician.js";
// import Getpoint from "@/components/map/Getpoint1.vue";
export default {
  // components: {
  //   /*腾讯地图拾取器*/
  //   Getpoint
  // },
  data() {
    return {
      aaa: "",
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      loading: false,
      dialogVisible: false,
      waiterUserId: "",
      addresslist: {},
      newform: {
        waiterUserId: "",
        new_lng: "",
        new_lat: "",
        new_address: "",
        city: ""
      },
      newdata: [],
      scope:''
    };
  },
  props: ["open_waitewaddress", "form"],
  created() {
    console.log(this.form,9090)
    this.dialogVisible = this.open_waitewaddress;
    this.waiterUserId = this.form.waiterUserId;
    this.getscope()
    
    // this.getpoyline();
    // this.newform.waiter_user_id = this.form.waiter_user_id;
    // this.getaddress();
  },
  methods: {
    getscope(){
      let self=this
      Technician.getjsscope({ waiterUserId: this.waiterUserId }, true).then(
        res => {
          self.scope=res.data
        })
    },
    // getpoyline() {
    //   let self = this;
    //   Technician.getpoyline({ waiter_user_id: this.waiter_user_id }, true).then(
    //     res => {
    //       // console.log(res.data);
    //       self.newdata = res.data;
    //     }
    //   );
    // },
    // /*获取经纬度*/
    // getMapdataFunc(e) {
    //   // console.log("获取经纬度", e);
    //   this.newform.new_lng = e.data[0].toFixed(6);
    //   this.newform.new_lat = e.data[1].toFixed(6);
    //   // this.newform.coordinate =
    //   //   e.data[0].toFixed(6) + "," + e.data[1].toFixed(6);
    // },

    // /*选择的地址*/
    // choseFunc(e) {
    //   this.newform.new_lng = e.location.lng;
    //   this.newform.new_lat = e.location.lat;
    //   this.newform.city = e.address_component.city;
    //   this.newform.new_address = e.address;
    // },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    // /*获取*/
    // getaddress() {
    //   let self = this;
    //   self.loading = true;
    //   // let params = self.form;
    //   Technician.getPositionData({ waiter_user_id: this.waiter_user_id }, true)
    //     .then(data => {
    //       self.loading = false;
    //       if (data.code == 1) {
    //         self.addresslist = data.data;
    //         self.newform.new_lng = data.data.new_lng;
    //         self.newform.city = data.data.city;
    //         self.newform.new_lat = data.data.new_lat;
    //         self.newform.new_address = data.data.new_address;
    //       }
    //     })
    //     .catch(error => {
    //       self.loading = false;
    //     });
    // },
    onSubmit(){
      let self = this;
          self.loading = true;
      Technician.jsscope({ waiter_user_id: this.waiter_user_id,scope:this.scope }, true)
      .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible(true);
          }
        })
        .catch(error => {
          self.loading = false;
        });
      
    },
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/technician/technicianlist/dialog/myaddressline.vue